/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallExecutionStatus } from './CallExecutionStatus';
import {
    CallExecutionStatusFromJSON,
    CallExecutionStatusFromJSONTyped,
    CallExecutionStatusToJSON,
} from './CallExecutionStatus';
import type { CreateCallExecutionRequest } from './CreateCallExecutionRequest';
import {
    CreateCallExecutionRequestFromJSON,
    CreateCallExecutionRequestFromJSONTyped,
    CreateCallExecutionRequestToJSON,
} from './CreateCallExecutionRequest';
import type { StructuredAnalysisResponse } from './StructuredAnalysisResponse';
import {
    StructuredAnalysisResponseFromJSON,
    StructuredAnalysisResponseFromJSONTyped,
    StructuredAnalysisResponseToJSON,
} from './StructuredAnalysisResponse';
import type { TargetCompany } from './TargetCompany';
import {
    TargetCompanyFromJSON,
    TargetCompanyFromJSONTyped,
    TargetCompanyToJSON,
} from './TargetCompany';

/**
 * 
 * @export
 * @interface CallExecutionRecord
 */
export interface CallExecutionRecord {
    /**
     * 
     * @type {string}
     * @memberof CallExecutionRecord
     */
    call_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CallExecutionRecord
     */
    lead_id?: string;
    /**
     * 
     * @type {TargetCompany}
     * @memberof CallExecutionRecord
     */
    target_company?: TargetCompany;
    /**
     * 
     * @type {Array<string>}
     * @memberof CallExecutionRecord
     */
    goal_list?: Array<string>;
    /**
     * 
     * @type {CallExecutionStatus}
     * @memberof CallExecutionRecord
     */
    status?: CallExecutionStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof CallExecutionRecord
     */
    conference_phone_numbers?: Array<string>;
    /**
     * The S3 key of the transcript
     * @type {string}
     * @memberof CallExecutionRecord
     */
    transcript_s3_key?: string;
    /**
     * The organization ID
     * @type {string}
     * @memberof CallExecutionRecord
     */
    organization_id?: string;
    /**
     * The status message to be displayed to the user
     * @type {string}
     * @memberof CallExecutionRecord
     */
    status_message?: string;
    /**
     * The analysis report data
     * @type {string}
     * @memberof CallExecutionRecord
     */
    report_data?: string;
    /**
     * Number of times this call was retried
     * @type {number}
     * @memberof CallExecutionRecord
     */
    retry_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CallExecutionRecord
     */
    use_test_phone_numbers?: boolean;
    /**
     * 
     * @type {StructuredAnalysisResponse}
     * @memberof CallExecutionRecord
     */
    structured_data?: StructuredAnalysisResponse;
    /**
     * 
     * @type {CreateCallExecutionRequest}
     * @memberof CallExecutionRecord
     */
    request_body?: CreateCallExecutionRequest;
    /**
     * 
     * @type {Date}
     * @memberof CallExecutionRecord
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CallExecutionRecord
     */
    updated_at?: Date;
    /**
     * The phone number that was called
     * @type {string}
     * @memberof CallExecutionRecord
     */
    target_phone_number?: string;
    /**
     * Whether the call execution was manually retried
     * @type {boolean}
     * @memberof CallExecutionRecord
     */
    manual_retry?: boolean;
}

/**
 * Check if a given object implements the CallExecutionRecord interface.
 */
export function instanceOfCallExecutionRecord(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CallExecutionRecordFromJSON(json: any): CallExecutionRecord {
    return CallExecutionRecordFromJSONTyped(json, false);
}

export function CallExecutionRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallExecutionRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'call_id': !exists(json, 'call_id') ? undefined : json['call_id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'target_company': !exists(json, 'target_company') ? undefined : TargetCompanyFromJSON(json['target_company']),
        'goal_list': !exists(json, 'goal_list') ? undefined : json['goal_list'],
        'status': !exists(json, 'status') ? undefined : CallExecutionStatusFromJSON(json['status']),
        'conference_phone_numbers': !exists(json, 'conference_phone_numbers') ? undefined : json['conference_phone_numbers'],
        'transcript_s3_key': !exists(json, 'transcript_s3_key') ? undefined : json['transcript_s3_key'],
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'status_message': !exists(json, 'status_message') ? undefined : json['status_message'],
        'report_data': !exists(json, 'report_data') ? undefined : json['report_data'],
        'retry_count': !exists(json, 'retry_count') ? undefined : json['retry_count'],
        'use_test_phone_numbers': !exists(json, 'use_test_phone_numbers') ? undefined : json['use_test_phone_numbers'],
        'structured_data': !exists(json, 'structured_data') ? undefined : StructuredAnalysisResponseFromJSON(json['structured_data']),
        'request_body': !exists(json, 'request_body') ? undefined : CreateCallExecutionRequestFromJSON(json['request_body']),
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updated_at': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'target_phone_number': !exists(json, 'target_phone_number') ? undefined : json['target_phone_number'],
        'manual_retry': !exists(json, 'manual_retry') ? undefined : json['manual_retry'],
    };
}

export function CallExecutionRecordToJSON(value?: CallExecutionRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'call_id': value.call_id,
        'lead_id': value.lead_id,
        'target_company': TargetCompanyToJSON(value.target_company),
        'goal_list': value.goal_list,
        'status': CallExecutionStatusToJSON(value.status),
        'conference_phone_numbers': value.conference_phone_numbers,
        'transcript_s3_key': value.transcript_s3_key,
        'organization_id': value.organization_id,
        'status_message': value.status_message,
        'report_data': value.report_data,
        'retry_count': value.retry_count,
        'use_test_phone_numbers': value.use_test_phone_numbers,
        'structured_data': StructuredAnalysisResponseToJSON(value.structured_data),
        'request_body': CreateCallExecutionRequestToJSON(value.request_body),
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'updated_at': value.updated_at === undefined ? undefined : (value.updated_at.toISOString()),
        'target_phone_number': value.target_phone_number,
        'manual_retry': value.manual_retry,
    };
}

